import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('VFX ErrorBoundary caught:', error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-[#F5F1E8] flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#0B3B2E]/70">Something went wrong</p>
          <h2 className="mt-3 font-serif text-[32px] text-[#0B3B2E] leading-tight">
            We hit a bump. Refresh to try again.
          </h2>
          <p className="mt-3 text-[14px] text-[#0E1F1A]/65">
            The team has been notified. Your data is safe.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-6 h-11 px-6 rounded-full bg-[#0B3B2E] text-[#F5F1E8] hover:bg-[#12503F] transition-colors text-[14px] font-medium"
          >
            Reload the page
          </button>
        </div>
      </div>
    );
  }
}
